import { Button, Grid, Backdrop, CircularProgress } from "@material-ui/core";
import { styles } from "@material-ui/pickers/views/Calendar/Calendar";
import { createBrowserHistory } from "history";
import React, { useState, } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PreStudyActivityDetail } from "../../components";
import PreStudyFilters from "../../components/pre-study/PreStudyFilters/PreStudyFilters";
import { AppLayout } from "../../templates";
import { APP_CONFIGS } from "../../_constants";
import { utilFunctions } from "../../_helpers";
import { StudyPreActivityFilterStructure, StudyPreActivityHeaders } from "../../_models/app.models"
import { alertActions, factoryActions, shiftActions } from "../../_redux/actions";
import { preStudyActions } from "../../_redux/actions/pre-study.action";
import { authorizationService } from "../../_services";
import mainStyles from "./preStudyPage.module.scss";

const PreStudyPage = (props) => {

    const history = createBrowserHistory({ forceRefresh: true })

    // get current path for this page and set page state accordingly
    const path = props.location.pathname.split('/');
    const lastFragment = path[path.length - 1];
    var pState = 'SEARCH';
    var studyHeaderId = props.match.params.id == undefined ? 0 : props.match.params.id;
    if (isNaN(lastFragment)) {
        pState = lastFragment;
    }
    else {
        pState = path[path.length - 2];
    }

    // Represents page state
    const INITIAL_PAGE_STATE = {
        preStudyHeader: {
            id: 0,
            plantCode: '',
            factoryCode: '',
            shiftCode: '',
            module: '',
            style: '',
            styleVersion: '',
            createdBy: authorizationService.getAuthorizedUser().id,
            version: 0,
            studyPreActivityDetails: []
        },
        pageState: pState.toLocaleUpperCase(),
        isFilteringDone: false,
        isErrorEncounterd: false,
        headerId: studyHeaderId,
        preStudyActivityDetailsForDetailComponent: [],
        errorMessage: '',
        studyDetailsDropdowns: {
            gsdCodes: [],
            operations: [],
            elementCategories: [],
            elementName: []
        },
        isToastMessageDisplayed: false,
        toastMessage: '',
        isClearButtonVisible: true,
        arefiltersDisabled: false,
        isLoading: false
    }
    const dispatch = useDispatch();
    const [preTimeStudyPageState, setPreTimeStudyPageState] = useState(INITIAL_PAGE_STATE);
    const sbuListState = useSelector((state: any) => state.factories.sbuList);
    const shiftListState = useSelector((state: any) => state.shifts.shiftList);


    const getPreStudyDetail = (id: number, filters: StudyPreActivityFilterStructure) => {

        setPreTimeStudyPageState({ ...preTimeStudyPageState, isLoading: true });

        dispatch(preStudyActions.getPreStudyHeaders(id, filters, (data) => {
            let preStudyHeaderRes: StudyPreActivityHeaders = { ...INITIAL_PAGE_STATE.preStudyHeader }
            let dependentDataFetchingRequired = true;
            if (data != null) {
                // In case header id is not provided then filter will be applied and array of records will be returned
                if (Array.isArray(data)) {
                    if (data.length > 0) {
                        preStudyHeaderRes = { ...data[0] }
                    }
                    else {
                        // filter values need to be sustained in case no records are found
                        preStudyHeaderRes = { ...filters, createdBy: authorizationService.getAuthorizedUser().id, version: 0, id: id, studyPreActivityDetails: [] };
                        dispatch(alertActions.triggerAlert(true, "No Pre Study detail found!", "info", 3000));
                    }

                }
                else if (data.id != undefined && data.id > 0) {
                    preStudyHeaderRes = { ...data };
                }
                else if (preTimeStudyPageState.pageState == "CREATE") {
                    preStudyHeaderRes = { ...filters, createdBy: authorizationService.getAuthorizedUser().id, version: 0, id: id, studyPreActivityDetails: [] };
                }
                else {
                    dispatch(alertActions.triggerAlert(true, "No Pre Study detail found!", "info", 3000));
                    dependentDataFetchingRequired = false;
                }

                if (dependentDataFetchingRequired) {
                    dispatch(preStudyActions.getGSDCodes((data: any) => {
                        let gsdCode = data;
                        let operations: any[];
                        let elementCategories: any[];
                        let elementNames: any[]
                        dispatch(preStudyActions.getOperations((data) => {
                            operations = data;
                            //get elementCategories
                            dispatch(preStudyActions.getElementCategory((data) => {
                                elementCategories = data;

                                //get elementName
                                dispatch(preStudyActions.getElementNames((data) => {
                                    elementNames = data;

                                    setPreTimeStudyPageState({
                                        ...preTimeStudyPageState
                                        , preStudyHeader: { ...preStudyHeaderRes }
                                        , isFilteringDone: true
                                        , isErrorEncounterd: false
                                        , preStudyActivityDetailsForDetailComponent: preStudyHeaderRes.studyPreActivityDetails
                                        , studyDetailsDropdowns: {
                                            gsdCodes: gsdCode,
                                            operations: operations,
                                            elementCategories: elementCategories,
                                            elementName: elementNames
                                        }
                                        , isClearButtonVisible: (preTimeStudyPageState.headerId == undefined || preTimeStudyPageState.headerId == 0)
                                        , arefiltersDisabled: (preTimeStudyPageState.headerId != undefined && preTimeStudyPageState.headerId != 0)
                                        , isLoading: false
                                    });

                                }, () => {
                                    setPreTimeStudyPageState({
                                        ...preTimeStudyPageState
                                        , isLoading: false
                                    })
                                }))

                            }, () => {
                                setPreTimeStudyPageState({
                                    ...preTimeStudyPageState
                                    , isLoading: false
                                })
                            }))

                        }, () => {
                            setPreTimeStudyPageState({
                                ...preTimeStudyPageState
                                , isLoading: false
                            })
                        }, preStudyHeaderRes.plantCode, preStudyHeaderRes.factoryCode, preStudyHeaderRes.module, preStudyHeaderRes.style, preStudyHeaderRes.styleVersion))

                    }, () => {

                        setPreTimeStudyPageState({
                            ...preTimeStudyPageState
                            , isLoading: false
                        })

                    }, preStudyHeaderRes.plantCode, preStudyHeaderRes.factoryCode, preStudyHeaderRes.module, preStudyHeaderRes.style, preStudyHeaderRes.styleVersion))
                }
            }

        }, (error) => {

            dispatch(alertActions.triggerAlert(true, "Error in fetching pre activity details", "Error", 2000))

            // In case of error show message no record found
            setPreTimeStudyPageState({
                ...preTimeStudyPageState
                , isFilteringDone: true
                , isErrorEncounterd: false
                , isLoading: false
            });
        }));
    }
    React.useEffect(() => {
        dispatch(shiftActions.getAllShiftList(() => { }, (error) => {
            // trigger alert onError
            dispatch(alertActions.triggerAlert(true, error, 'error'))
        }))

        // dispatch getAllSbuList action & fetch SBU List
        dispatch(
            factoryActions.getAllSbuList(
                authorizationService.getAuthorizedUser().isAdmin,
                authorizationService.getAuthorizedUser().userEmail,
                () => { },
                (error) => {
                    dispatch(alertActions.triggerAlert(true, error, 'error'))
                }
            )
        );

        //If search by id is requested        
        if (preTimeStudyPageState.headerId != 0 && preTimeStudyPageState.pageState != 'CREATE') {
            getPreStudyDetail(preTimeStudyPageState.headerId, undefined);
        }

    }, [])

    const onFilterClear = () => {
        setPreTimeStudyPageState(INITIAL_PAGE_STATE);
        if (preTimeStudyPageState.headerId != 0) {
            props.history.push('prestudy/search');
        }
    }

    const onFilterChange = (filters: StudyPreActivityFilterStructure | null) => {
        getPreStudyDetail(preTimeStudyPageState.headerId, filters);
    }

    const onSave = (details) => {

        setPreTimeStudyPageState({
            ...preTimeStudyPageState,
            preStudyActivityDetailsForDetailComponent: details,
            isLoading: true
        });

        let isUpdated = preTimeStudyPageState.preStudyHeader.id != undefined && preTimeStudyPageState.preStudyHeader.id > 0;
        dispatch(preStudyActions.addPreActivityStudyHeader({ ...preTimeStudyPageState.preStudyHeader, studyPreActivityDetails: [...details] }

            // here on sucess will display a message that record is saved and will redirect to that particular component with id
            , (data) => {

                dispatch(alertActions.triggerAlert(true, `Header details ${isUpdated ? "updated" : "created"} successfully, Page will be redirected to Pre Study detail!`
                    , 'success', 2000
                ))

                setTimeout(() => {
                    history.push(`/prestudy/search/${data.id}`)
                }, 2000)
            }

            // here on error will show error message and then allow user to resubmit again
            , (err) => {
                dispatch(alertActions.triggerAlert(true, `Error in ${isUpdated ? "updating" : "creating"} header details.`
                    , 'error', 2000
                ))
                setPreTimeStudyPageState({
                    ...preTimeStudyPageState,
                    isLoading: false
                })

            }))
    }

    const onEditDetail = () => {
        setPreTimeStudyPageState({
            ...preTimeStudyPageState,
            arefiltersDisabled: true
        })
    }

    return (
        <>
            <Backdrop
                open={preTimeStudyPageState.isLoading}
                className={mainStyles.MuiBackdrop_root}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <AppLayout isbackDropOpen={true}>
                <Grid container className={'appPageHeader'}>
                    <Grid container item xs={12} sm={12} md={7} lg={7} justify="flex-start" alignContent="center">
                        <span className={'pageTitle'}>Pre Activity <b>Template</b></span>
                    </Grid>
                    <Grid container item xs={12} sm={12} md={2} lg={2} justify="flex-end" alignContent="center">

                    </Grid>
                    <Grid container item xs={12} sm={12} md={3} lg={3} justify="flex-end" alignContent="center">
                        {preTimeStudyPageState.pageState != "CREATE" &&
                            <Button variant="contained" color="secondary" onClick={() => { history.push('/prestudy/create') }}>
                                Create Pre Activity
                            </Button>
                        }
                    </Grid>
                </Grid>

                <div className="appPageContent">
                    <PreStudyFilters
                        onFilterClear={() => { onFilterClear() }}
                        onFilterChange={(filters) => { onFilterChange(filters) }}
                        sbus={sbuListState.data}
                        studyHeader={preTimeStudyPageState.preStudyHeader}
                        pageState={preTimeStudyPageState.pageState}
                        showClearButton={preTimeStudyPageState.isClearButtonVisible}
                        isPreStudyControlsDisabled={preTimeStudyPageState.arefiltersDisabled}
                        shifts={shiftListState.data}
                    />
                    {(preTimeStudyPageState.pageState == 'CREATE' || (preTimeStudyPageState.isFilteringDone && preTimeStudyPageState.preStudyHeader != null && preTimeStudyPageState.preStudyHeader.id != 0 && preTimeStudyPageState.preStudyHeader.studyPreActivityDetails != null && preTimeStudyPageState.preStudyHeader.studyPreActivityDetails.length >= 0)) &&
                        <PreStudyActivityDetail
                            onSave={onSave}
                            pageState={preTimeStudyPageState.pageState}
                            preStudyHeader={preTimeStudyPageState.preStudyHeader}
                            studyPreActivityDetails={preTimeStudyPageState.preStudyActivityDetailsForDetailComponent}
                            dropDownData={preTimeStudyPageState.studyDetailsDropdowns}
                            onEdit={onEditDetail}
                            isWebview={utilFunctions.isWebView(navigator.userAgent, APP_CONFIGS.TULITA_APP_USER_AGENT)}
                        />
                    }
                    {preTimeStudyPageState.isErrorEncounterd && <div>{preTimeStudyPageState.errorMessage}</div>}
                </div>
            </AppLayout>
        </>
    )

}

export default PreStudyPage;